import React, { useEffect, useState } from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
import Select from "react-select";

const selectStyles = {
  menu: (baseStyles, state) => ({
    ...baseStyles,
    marginTop: 2,
    zIndex: 999,
  }),
};

const Size = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);
  const [userDrp, setUserDrp] = useState([]);
  const [user, setUser] = useState(null);

  const fetchListData = () => {
    axios.post(API_URL.SIZE_LIST, { user_id: user }).then(
      (res) => {
        if (res.data.status === 1) {
          setListData(res.data.data);
        }
        setLoading(false);
        if (sessionStorage.getItem('pId')) {
          let rId = 'row-' + JSON.parse(sessionStorage.getItem('pId'));
          setTimeout(() => {
            scrollToRow(rId);
          }, 100)
        }
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-center",
        });
      }
    );
  };

  const editProduct = (id) => {
    if (user) {
      sessionStorage.setItem('pUser', JSON.stringify(user));
    }
    sessionStorage.setItem('pId', JSON.stringify(id));
    navigate("/admin/size/edit/" + id);
    }
 

  const deleteSize = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SIZE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = listData.filter((r) => r.id != row.id);
              setListData(newData);
            }
            toast.success("Delete Successfully", {
              autoClose: 3000,
              position: "top-center",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-center",
            });
          }
        );
      }
    });
  };

  const fetchUserData = () => {
    setLoading(true);
    axios.post(API_URL.USER_LIST, {}).then((res) => {
      setUserDrp(
        res.data.data.data.map((user) => {
          return {
            label: user.name,
            value: user.id,
          };
        })
      );
      setLoading(false);
    });
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (!res.data.is_allowed) {
          setUser(res.data.id);
        } else {
          fetchUserData();
        }
      }
    });
  };

  useEffect(() => {
    user && fetchListData();
  }, [user]);

  useEffect(() => {
    userInfo();
    if (sessionStorage.getItem('pUser')) {
      setUser(JSON.parse(sessionStorage.getItem('pUser')))
    }
  }, []);

  const scrollToRow = (rowId) => {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <>
      <PageHeader
        pageTitle={"Size"}
        count={listData.length}
        // searchValue={searchValue}
        // setSearchValue={searchParty}
        addPageUrl={"/admin/size/add"}
      />
      <div className="d-flex">
        {isAllowed && (
          <div className="form-group me-3" style={{ width: "300px" }}>
            <Select
              options={userDrp}
              placeholder="Select User..."
              value={userDrp.find((d) => d.value === user)}
              styles={selectStyles}
              onChange={(e) => {
                setUser(e.value);
              }}
            />
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Client</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listData.map((row, key) => {
                        return (
                          <tr id={"row-" + row.id} key={key}>
                            <td className="td-hash">{key + 1}</td>
                            <td>{row.name}</td>
                            <td>{row.user.name}</td>
                            <td className="td-action">
                              <div>
                                <button
                                  onClick={() => editProduct(row.id)}
                                  className="btn btn-sm btn-secondary"
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                                <button
                                  onClick={() => deleteSize(row)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Size;
